{
  "close": "Lukk",
  "notifications": "{count, plural, one {# varsling} other {# varsler}}."
}
